import { render, staticRenderFns } from "./ChangeLogPage.vue?vue&type=template&id=4c6759d9&scoped=true&"
import script from "./ChangeLogPage.vue?vue&type=script&lang=js&"
export * from "./ChangeLogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6759d9",
  null
  
)

export default component.exports